<template>
  <v-container>
    <vue-event-calendar :title="'Calendar of Activities'" :events="demoEvents"></vue-event-calendar>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data () {
    return {
      demoEvents: []
    }
  },
  created(){
    // ADD TIME TO DESCRIPTION
    axios.get('/api/calendar/0')
      .then(event => {
        let mapped = event.data.map(details => {
          return {
            date: details.start_date.split('-').join('/'),
            title: details.name,
            desc: `
              Range: ${ moment(details.start_date).format('MMMM D, YYYY') } - ${ moment(details.end_date).format('MMMM D, YYYY') } |
              Description: ${ details.description }
            `
          }
        })
        this.demoEvents = mapped
      }).catch(e => {
        console.log(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/Calendar.vue